var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "checkout-form__tip" },
    [
      _vm.options.length > 1
        ? _c(
            "div",
            {
              staticClass: "checkout-form__tip-buttons",
              class:
                ((_obj = {
                  "checkout-form__tip-buttons--grid": _vm.variant.grid
                }),
                (_obj["checkout-form__tip-buttons--grid-" + _vm.variant.grid] =
                  _vm.variant.grid),
                _obj)
            },
            [
              _vm._l(_vm.options, function(option, index) {
                return _c(
                  "label",
                  {
                    key: index,
                    staticClass: "checkout-form__tip-button",
                    class: {
                      "checkout-form__tip-button--span": option.span
                    }
                  },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedOptionIndex,
                          expression: "selectedOptionIndex"
                        }
                      ],
                      staticClass: "checkout-form__tip-button-input",
                      attrs: {
                        type: "radio",
                        name: _vm.uniqueId,
                        disabled: _vm.locked
                      },
                      domProps: {
                        value: index,
                        checked: _vm._q(_vm.selectedOptionIndex, index)
                      },
                      on: {
                        input: function($event) {
                          return _vm.onSelect(option, index)
                        },
                        change: function($event) {
                          _vm.selectedOptionIndex = index
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "checkout-form__tip-button-text",
                      domProps: { innerHTML: _vm._s(option.label) }
                    })
                  ]
                )
              }),
              _vm._v(" "),
              _vm.selectedOption &&
              _vm.selectedOption.options &&
              _vm.selectedOption.options.length > 1
                ? _vm._l(_vm.selectedOption.options, function(option, index) {
                    return _c(
                      "label",
                      {
                        key: _vm.selectedOptionIndex + "-" + index,
                        staticClass: "checkout-form__tip-button",
                        class: {
                          "checkout-form__tip-button--span": option.span
                        }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedSubOptionIndex,
                              expression: "selectedSubOptionIndex"
                            }
                          ],
                          staticClass: "checkout-form__tip-button-input",
                          attrs: {
                            type: "radio",
                            name: _vm.selectedOptionIndex + _vm.uniqueId,
                            disabled: _vm.locked
                          },
                          domProps: {
                            value: index,
                            checked: _vm._q(_vm.selectedSubOptionIndex, index)
                          },
                          on: {
                            input: function($event) {
                              return _vm.onSelect(
                                option,
                                _vm.selectedOptionIndex,
                                index
                              )
                            },
                            change: function($event) {
                              _vm.selectedSubOptionIndex = index
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "checkout-form__tip-button-text",
                          domProps: { innerHTML: _vm._s(option.label) }
                        })
                      ]
                    )
                  })
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deepestSelectedOption && _vm.deepestSelectedOption.range
        ? _c("FormInputRange", {
            staticClass: "checkout-form__tip-input",
            attrs: {
              min: _vm.deepestSelectedOption.range.min || 0,
              max: _vm.deepestSelectedOption.range.max || 100,
              step: _vm.deepestSelectedOption.range.step || 1,
              "hide-value": "",
              disabled: _vm.locked
            },
            model: {
              value: _vm.rangeValue,
              callback: function($$v) {
                _vm.rangeValue = _vm._n($$v)
              },
              expression: "rangeValue"
            }
          })
        : _vm.deepestSelectedOption && _vm.deepestSelectedOption.input
        ? _c("FormInputCurrency", {
            ref: "subInput",
            staticClass: "checkout-form__tip-input",
            attrs: {
              placeholder: _vm.deepestSelectedOption.label,
              label: _vm.deepestSelectedOption.label,
              attributes: Object.assign(
                {},
                { min: 0, step: 0.05 },
                _vm.getInputAttributes(_vm.deepestSelectedOption.input)
              ),
              disabled: _vm.locked
            },
            model: {
              value: _vm.inputValue,
              callback: function($$v) {
                _vm.inputValue = _vm._n($$v)
              },
              expression: "inputValue"
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.selectedOption && _vm.selectedOption.type !== "none"
        ? _c("div", { staticClass: "checkout-form__tip-value" }, [
            _vm.selectedOption.type === "percent"
              ? _c("span", {
                  staticClass: "checkout-form__tip-value-percent",
                  domProps: { innerHTML: _vm._s(_vm.tipPercent + "%") }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("span", {
              staticClass: "checkout-form__tip-value-currency",
              domProps: { innerHTML: _vm._s(_vm.displayValue) }
            })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "additional-info text--highlight" }, [
        _c("span", {
          domProps: { innerHTML: _vm._s(_vm.$t("cart.tipMessage")) }
        }),
        _vm._v(" "),
        _vm.tip
          ? _c("span", {
              domProps: { innerHTML: _vm._s(_vm.$t("cart.tipMessageThanks")) }
            })
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }